var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"announce"},[_c('ListTitle',{attrs:{"title":_vm.title,"titleImg":_vm.titleImg}}),_c('ListGroup',{attrs:{"itemList":_vm.itemList,"fn":_vm.goToDetails}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }